"use strict";
/*
 * Created on 29. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Simple implementation of sparse matrix backed by array of triplets (row, column, value). To support different type
 * of row and column specifier, custom comparators must be provided during initialization.
 * @author Stepan Mik
 */

var SparseMatrix =
/*#__PURE__*/
function () {
  /**
   * @param defValue default value (value of cell that is not stored in the matrix)
   * @param rowComparator comparator of row specifiers
   * @param colComparator comparator of column specifiers. Must accept null as first parameter and treat it as
   * lesser than any other C
   */
  function SparseMatrix(defValue, rowHandler, colHandler) {
    _classCallCheck(this, SparseMatrix);

    this.defValue = defValue;
    this.rowHandler = rowHandler;
    this.colHandler = colHandler;
    this.cells = [];
    this._cols = new Map();
    this._rows = new Map();
    this.modCnt = 0;
    this.setVersion = 0;
    /**/
  }

  _createClass(SparseMatrix, [{
    key: "intern",
    value: function intern(a, set, handler) {
      var key = handler.intern(a);
      var iv = set.get(key);

      if (iv === undefined) {
        iv = a;
        set.set(key, a);
      }

      return iv;
    }
  }, {
    key: "assert",
    value: function assert(row, col) {
      if (row === null || col === null || row === undefined || col === undefined) {
        throw new Error('Row and Col must not be null');
      }
    }
  }, {
    key: "set",
    value: function set(row, col, value) {
      this.assert(row, col);
      row = this.rowHandler.normalize(row);
      col = this.colHandler.normalize(col);
      var i = this.indexOf(row, col);

      if (i >= 0) {
        if (value !== this.defValue) {
          this.cells[i][2] = value;
        } else {
          this.cells.splice(i, 1);
          this.modCnt++;
        }
      } else {
        if (value !== this.defValue) {
          i = -i - 1;
          this.cells.splice(i, 0, [this.intern(row, this._rows, this.rowHandler), this.intern(col, this._cols, this.colHandler), value]);
        }
      }
    }
  }, {
    key: "update",
    value: function update(row, col, upd) {
      this.assert(row, col);
      row = this.rowHandler.normalize(row);
      col = this.colHandler.normalize(col);
      var i = this.indexOf(row, col);

      if (i >= 0) {
        var value = upd(this.cells[i][2]);

        if (value !== this.defValue) {
          this.cells[i][2] = value;
        } else {
          this.cells.splice(i, 1);
          this.modCnt++;
        }
      } else {
        this.set(row, col, upd(this.defValue));
      }
    }
  }, {
    key: "modify",
    value: function modify(mod) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.cells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var cell = _step.value;
          cell[2] = mod(cell[2], cell[0], cell[1]);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
    /**
     * Maps this matrix to new one by computing value of each cell.
     * @param dv default value for new matrix
     * @param f mapping function from cell values to new cell values. The function
     *  is called with value of the cell and cell 'coordinates'
     */

  }, {
    key: "map",
    value: function map(dv, f) {
      var ret = new SparseMatrix(dv, this.rowHandler, this.colHandler);
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this._cols.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var e = _step2.value;

          ret._cols.set(e[0], e[1]);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this._rows.entries()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _e = _step3.value;

          ret._rows.set(_e[0], _e[1]);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = this.cells[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _step4$value = _slicedToArray(_step4.value, 3),
              r = _step4$value[0],
              c = _step4$value[1],
              v = _step4$value[2];

          ret.cells.push([r, c, f(v, r, c)]);
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      return ret;
    }
  }, {
    key: "get",
    value: function get(row, col) {
      this.assert(row, col);
      row = this.rowHandler.normalize(row);
      col = this.colHandler.normalize(col);
      var i = this.indexOf(row, col);
      return i >= 0 ? this.cells[i][2] : this.defValue;
    }
  }, {
    key: "getOrDefault",
    value: function getOrDefault(row, col, defv) {
      this.assert(row, col);
      row = this.rowHandler.normalize(row);
      col = this.colHandler.normalize(col);
      var i = this.indexOf(row, col);
      return i >= 0 ? this.cells[i][2] : defv;
    }
  }, {
    key: "cmp",
    value: function cmp(row, col, cell) {
      var r = this.rowHandler.compare(row, cell[0]);

      if (r === 0) {
        return this.colHandler.compare(col, cell[1]);
      }

      return r;
    } //tslint:disable:no-bitwise

  }, {
    key: "indexOf",
    value: function indexOf(row, col) {
      var low = 0;
      var high = this.cells.length - 1;

      while (low <= high) {
        var mid = low + high >>> 1;
        var cmp = this.cmp(row, col, this.cells[mid]);

        if (cmp > 0) {
          low = mid + 1;
        } else if (cmp < 0) {
          high = mid - 1;
        } else {
          return mid; // key found
        }
      }

      return -(low + 1); // key not found.
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.cells[Symbol.iterator]();
    }
  }, {
    key: "hasRow",
    value: function hasRow(row) {
      if (this.modCnt > this.setVersion) {
        this.updateSets();
      }

      return this._rows.has(this.rowHandler.intern(row));
    }
  }, {
    key: "hasCol",
    value: function hasCol(col) {
      if (this.modCnt > this.setVersion) {
        this.updateSets();
      }

      return this._cols.has(this.colHandler.intern(col));
    }
  }, {
    key: "updateSets",
    value: function updateSets() {
      this._cols.clear();

      this._rows.clear();

      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = this.cells[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var c = _step5.value;
          var rk = this.rowHandler.intern(c[0]);

          if (!this._rows.has(rk)) {
            this._rows.set(rk, c[0]);
          }

          var ck = this.colHandler.intern(c[1]);

          if (!this._cols.has(ck)) {
            this._cols.set(ck, c[1]);
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      this.setVersion = 0;
      this.modCnt = 0;
    }
  }, {
    key: "row",
    value: function row(r) {
      var self = this;
      r = this.rowHandler.normalize(r);

      var iterable = _defineProperty({}, Symbol.iterator, function () {
        var idx = -(self.indexOf(r, null) + 1);
        return {
          next: function next() {
            if (idx < self.cells.length && self.rowHandler.compare(r, self.cells[idx][0]) === 0) {
              var i = idx++;
              return {
                done: false,
                value: [self.cells[i][1], self.cells[i][2]]
              };
            } else {
              return {
                done: true,
                value: [undefined, undefined]
              };
            }
          }
        };
      });

      return iterable;
    }
  }, {
    key: "col",
    value: function col(c) {
      var self = this;
      c = this.colHandler.normalize(c);
      return _defineProperty({}, Symbol.iterator, function () {
        var rowIt = self.rows[Symbol.iterator]();
        return {
          next: function next() {
            var idx;

            do {
              var r = rowIt.next();

              if (!r.done) {
                idx = self.indexOf(r.value, c);
              }
            } while (idx !== undefined && idx < 0);

            return idx === undefined ? {
              done: true,
              value: [undefined, undefined]
            } : {
              done: false,
              value: [self.cells[idx][0], self.cells[idx][2]]
            };
          }
        };
      });
    }
  }, {
    key: "merge",
    value: function merge(other, combinator) {
      this.doMerge(0, 0, other, combinator, function () {
        return false;
      });
    }
  }, {
    key: "mergeRow",
    value: function mergeRow(other, row, combinator) {
      var row1 = this.rowHandler.normalize(row);
      var row2 = other.rowHandler.normalize(row);
      var i = -(this.indexOf(row1, null) + 1);
      var j = -(other.indexOf(row2, null) + 1);
      this.doMerge(i, j, other, combinator, function (r, c) {
        return other.rowHandler.compare(r, row2) !== 0;
      });
    }
  }, {
    key: "doMerge",
    value: function doMerge(i, j, other, combinator, term) {
      while (i < this.cells.length || j < other.cells.length) {
        if (j < other.cells.length && term(other.cells[j][0], other.cells[j][1])) {
          break;
        }

        if (i >= this.cells.length) {
          this.cells.push([this.intern(other.cells[j][0], this._rows, this.rowHandler), this.intern(other.cells[j][1], this._cols, this.colHandler), combinator(this.defValue, other.cells[j][2])]);
          j++;
          i++;
        } else if (j >= other.cells.length) {
          i = this.cells.length;
        } else {
          var cmp = this.cmp(other.cells[j][0], other.cells[j][1], this.cells[i]);

          if (cmp > 0) {
            i++;
          } else if (cmp < 0) {
            this.cells.splice(i, 0, [this.intern(other.cells[j][0], this._rows, this.rowHandler), this.intern(other.cells[j][1], this._cols, this.colHandler), combinator(this.defValue, other.cells[j][2])]);
            i++;
            j++;
          } else {
            this.cells[i][2] = combinator(this.cells[i][2], other.cells[j][2]);
            i++;
            j++;
          }
        }
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this._rows.clear();

      this._cols.clear();

      this.setVersion = 0;
      this.modCnt = 0;
      this.cells = [];
    }
  }, {
    key: "size",
    get: function get() {
      return this.cells.length;
    }
  }, {
    key: "rows",
    get: function get() {
      if (this.modCnt > this.setVersion) {
        this.updateSets();
      }

      return this._rows.values();
    }
  }, {
    key: "cols",
    get: function get() {
      if (this.modCnt > this.setVersion) {
        this.updateSets();
      }

      return this._cols.values();
    }
  }], [{
    key: "stringStringMatrix",
    value: function stringStringMatrix(defVal) {
      return new SparseMatrix(defVal, SparseMatrix.stringComparator, SparseMatrix.stringComparator);
    }
  }, {
    key: "intIntMatrix",
    value: function intIntMatrix(defVal) {
      return new SparseMatrix(defVal, SparseMatrix.intComparator, SparseMatrix.intComparator);
    }
  }]);

  return SparseMatrix;
}();

exports.SparseMatrix = SparseMatrix;
SparseMatrix.stringComparator = {
  normalize: function normalize(a) {
    return a;
  },
  intern: function intern(a) {
    return a;
  },
  compare: function compare(s1, s2) {
    if (s1 === null) {
      return -1;
    }

    if (s1 === s2) {
      return 0;
    }

    return s1 > s2 ? 1 : -1;
  }
};
SparseMatrix.intComparator = {
  normalize: function normalize(a) {
    return Math.floor(a);
  },
  intern: function intern(a) {
    return a;
  },
  compare: function compare(n1, n2) {
    if (n1 === null) {
      return -1;
    }

    if (n1 < n2) {
      return -1;
    }

    if (n1 > n2) {
      return 1;
    }

    return 0;
  }
};